import api from 'api';

interface WorkerEvictionResult {
  evicting_task_ids: string[];
}

/**
 * Evict running tasks from a draining or retiring worker. The tasks are stopped
 * on the worker and re-queued by the backend (not cancelled). Omitting task_ids
 * evicts all running tasks on the worker.
 */
export default function evictWorkerTasks(workerId: string, taskIds?: string[]): Promise<WorkerEvictionResult> {
  return api.post(`workers/${workerId}/evictions`, { json: { task_ids: taskIds ?? null } }).json();
}
